import React from 'react';
import { Modal, Button, Typography } from 'antd';
import styled from 'styled-components';
import { WifiOutlined } from '@ant-design/icons';

interface NoInternetModalProps {
    visible: boolean;
    onRetry: () => void;
}

const NoInternetModal: React.FC<NoInternetModalProps> = ({ visible, onRetry }) => {
    return (
        <StyledModal
            visible={visible}
            centered
            closable={false}
            footer={null}
            width={400}
            maskClosable={false}
        >
            <ModalContent>
                <IconWrapper>
                    <WifiIconStyled />
                </IconWrapper>

                <Title level={4}>No Internet Connection</Title>

                <Description>
                    Please check your connection and try again.
                </Description>

                <RetryButton type="primary" onClick={onRetry}>
                    Retry
                </RetryButton>

                <Note>
                    Note: Your payment has been received and your service is now active.
                    A confirmation email has been sent to you.
                </Note>
            </ModalContent>
        </StyledModal>
    );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    padding: 24px;
    background: #ffffff;
  }
  
  .ant-modal-body {
    padding: 0;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 16px;
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #E8F4F8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const WifiIconStyled = styled(WifiOutlined)`
  font-size: 40px;
  color: #1890ff;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    width: 2px;
    height: 40px;
    background: #1890ff;
    transform: rotate(45deg);
    top: 50%;
    left: 50%;
    margin-left: -1px;
    margin-top: -20px;
  }
`;

const Title = styled(Typography.Title)`
  && {
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin-bottom: 12px;
    font-family: 'Inter', sans-serif;
  }
`;

const Description = styled(Typography.Paragraph)`
  && {
    font-size: 14px;
    color: #666666;
    margin-bottom: 24px;
    font-family: 'Inter', sans-serif;
  }
`;

const RetryButton = styled(Button)`
  && {
    width: 100%;
    height: 44px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    background: #0069B1;
    border-color: #0069B1;
    margin-bottom: 20px;
    
    &:hover, &:focus {
      background: #005a96;
      border-color: #005a96;
    }
  }
`;

const Note = styled(Typography.Paragraph)`
  && {
    font-size: 12px;
    color: #999999;
    margin: 0;
    line-height: 1.6;
    font-family: 'Inter', sans-serif;
  }
`;

export default NoInternetModal;
